module.exports = __webpack_public_path__ + "img/sagar-round.a8c94978.png";